<div class="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-[#02040a] text-slate-200 font-sans selection:bg-cyan-500/30 selection:text-cyan-200">
  
  <!-- Cinematic Background -->
  <div class="fixed inset-0 w-full h-full overflow-hidden pointer-events-none">
    <!-- Grid Pattern -->
    <div class="absolute inset-0 bg-[url('/assets/grid.svg')] bg-center [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_70%)] opacity-[0.05]"></div>
    
    <!-- Deep Atmosphere -->
    <div class="absolute top-[-20%] left-[-10%] w-[100vw] h-[100vw] bg-blue-950/20 rounded-full blur-[150px] mix-blend-screen"></div>
    <div class="absolute bottom-[-20%] right-[-10%] w-[100vw] h-[100vw] bg-cyan-950/20 rounded-full blur-[150px] mix-blend-screen"></div>
    
    <!-- Subtle Pulse Center -->
    <div class="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 w-[50vw] h-[50vw] bg-indigo-500/5 rounded-full blur-[120px] animate-pulse-slow"></div>
    
    <!-- Noise Overlay -->
    <div class="absolute inset-0 opacity-[0.03] bg-noise mix-blend-overlay"></div>
  </div>

  <!-- Main Container -->
  <div class="relative z-10 w-full max-w-[26rem] px-6">
    
    <!-- Logo Showcase -->
    <div class="flex flex-col items-center mb-10 relative z-20">
        <div class="relative mb-6 group cursor-default">
            <!-- Glow behind logo -->
            <div class="absolute inset-0 bg-cyan-500/10 blur-[50px] rounded-full transform scale-150 opacity-50 group-hover:opacity-75 transition-opacity duration-1000"></div>
            
            <!-- Logo -->
            <div class="relative transition-transform duration-700 hover:scale-105">
                <img src="floodwaive-logo.svg" alt="FloodWaive" class="h-20 w-auto drop-shadow-[0_0_25px_rgba(6,182,212,0.15)]" />
            </div>
        </div>
        
        <!-- Refined Title -->
        <div class="text-center space-y-2">
            <h1 class="text-lg font-light tracking-[0.2em] text-cyan-100/80 uppercase">
                Secure Gateway
            </h1>
        </div>
    </div>

    <!-- Glass Card -->
    <div class="backdrop-blur-2xl bg-white/[0.02] border border-white/[0.06] shadow-[0_0_40px_-10px_rgba(0,0,0,0.7)] rounded-2xl p-8 relative overflow-hidden transition-colors duration-500 hover:bg-white/[0.03] hover:border-white/[0.08]">
      
      <!-- Header Info -->
      <div class="text-center mb-8">
        @if (host()) {
            <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-cyan-950/30 border border-cyan-500/20 text-xs text-cyan-200/70 shadow-[0_0_10px_rgba(6,182,212,0.1)]">
                <i class="pi pi-shield text-[10px]"></i>
                <span class="tracking-wide">Host: <span class="font-medium text-cyan-100">{{ host() }}</span></span>
            </div>
        } @else {
            <p class="text-xs text-slate-500 tracking-wide uppercase">Identity Verification</p>
        }
      </div>

      <!-- Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
        
        <div class="space-y-1">
            <label for="password" class="sr-only">Password</label>
            <div class="relative group/input">
                <p-password 
                    formControlName="password" 
                    [feedback]="false" 
                    [toggleMask]="true" 
                    styleClass="w-full" 
                    [inputStyleClass]="'w-full bg-black/40 border border-white/10 text-slate-200 placeholder:text-slate-600/50 rounded-lg px-4 py-3.5 text-sm focus:border-cyan-500/40 focus:bg-black/60 focus:ring-1 focus:ring-cyan-500/20 transition-all duration-300 outline-none shadow-inner'"
                    placeholder="Enter Password"
                    id="password">
                </p-password>
            </div>
        </div>

        <!-- Error -->
        @if (loginError()) {
            <div class="px-4 py-3 rounded-lg bg-red-950/20 border border-red-500/20 text-red-300/90 text-xs flex items-center justify-center gap-2 animate-shake">
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ loginError() }}</span>
            </div>
        }

        <!-- Button -->
        <p-button 
            type="submit" 
            label="Sign In" 
            [loading]="isLoading()" 
            [disabled]="loginForm.invalid"
            styleClass="w-full"
            [style]="{ 'border-radius': '0.5rem' }"
            class="w-full block shadow-lg shadow-black/20">
        </p-button>

      </form>
    </div>

    <!-- Minimal Footer -->
    <div class="mt-12 flex justify-center opacity-30 hover:opacity-50 transition-opacity duration-500">
        <div class="h-1 w-1 rounded-full bg-slate-500 mx-1"></div>
        <div class="h-1 w-1 rounded-full bg-slate-500 mx-1"></div>
        <div class="h-1 w-1 rounded-full bg-slate-500 mx-1"></div>
    </div>
  </div>
</div>
